<template>
  <div class="doTest" v-if="question_list[index]">
    <header-info
      :week_info="week_info"
      :question_list="question_list"
      :index="index"
      :timesCN="timesCN"
    ></header-info>
    <div class="mes">
      <div class="mes-left">
        <div class="left-header">
          <div class="header-number" style="display:flex;align-items:center">
            第
            <span style="display:block;margin:auto 16px;">{{index+1}}</span>题
          </div>
          <div class="header-audio">
            <div @click="switchAudioPlay" :class="{'audio-switch': true, 'off': !isAudioSwitchOn}">
              <div class="switch-item"></div>
            </div>
            <div class="audio-info">语音读题</div>
          </div>
        </div>
        <div class="left-footer">{{ question_list[index].desc}}</div>
      </div>
      <div class="mes-right" @click="showRelusModel">
        <img src="../assets/imgs/question/rules.png" alt />
      </div>
    </div>
    <!-- <van-dialog v-if="isRight" v-model="show" confirm-button-text="下一题" :before-close="rightAnswer">
      <img src="../assets/imgs/question/right.png" class="right-img" alt />
      <div class="right-text">回答正确！</div>
    </van-dialog>
    <van-dialog
      v-if="!isRight"
      v-model="show"
      show-confirm-button
      show-cancel-button
      cancel-button-text="重做本题"
      cancel-button-color="#000"
      confirm-button-text="下一题"
      confirm-button-color="#e4393c"
      :before-close="wrongAnswer"
    >
      <img src="../assets/imgs/question/wrong.png" class="right-img" alt />
      <div class="right-text">答错啦！</div>
    </van-dialog>-->
    <!--做题-->
    <div class="answers">
      <!-- <div class="btn-img">
        <img src="../assets/imgs/question/prev.png" alt @click.stop="toLastQuestion">
      </div>-->
      <div class="answers-choose">
        <!-- 执行题 -->
        <topic-zero
          v-if="question_list[index].t_type===0"
          :question="question_list[index]"
          @getResult_chess="getResult_chess"
          :reload="reload"
          :genre="'test'"
        ></topic-zero>
        <!-- 判断题 -->
        <topic-one
          v-if="question_list[index].t_type===1"
          :question="question_list[index]"
          :reload="reload"
          @getResult_judge="getResult_judge"
          :genre="'test'"
        ></topic-one>
        <!-- 单选题 -->
        <topic-two
          v-if="question_list[index].t_type===2"
          :question="question_list[index]"
          @getResult_single="getResult_single"
          :reload="reload"
          :genre="'test'"
        ></topic-two>
        <!-- 其他类型 -->
        <topic-three
          v-if="question_list[index].t_type===3 || question_list[index].t_type===4"
          :question="question_list[index]"
          @getResult_qt="getResult_qt"
          :reload="reload"
          :genre="'test'"
        ></topic-three>
      </div>
      <!-- <div class="btn-img">
        <img  src="../assets/imgs/question/next.png" alt @click.stop="toNextQuestion">
      </div>-->
    </div>
    <!-- 下标回答状态 -->
    <!-- <div class="body-footer">
      <div @click="goIndex(i)" class="body-footer-item" v-for="(item,i) in question_list " :key="i">
        {{i+1}}
        <template v-if="typeof item.right === 'boolean'">
          <img class="right" v-if="item.right" src="../assets/imgs/question/isright.png"/>
          <img class="wrong" v-if="!item.right" src="../assets/imgs/question/iswrong.png"/>
        </template>
        <img class="index" v-if="index==i" src="../assets/imgs/question/isindex.png"/>
      </div>
    </div>-->
    <question-num :question_list="question_list" :index="index"></question-num>
    <!-- 做题的研究模式 暂时不要研究模式-->
    <!-- <div class="researchText" v-if="question_list[index].t_type===0">当前模式：正常模式</div>
    <div class="researchButton" v-if="question_list[index].t_type===0" @click="gotoResearchMode">进入研究模式</div>
    <research-mode
      v-if="researchModeShow"
      @closeResearchMode="closeResearch"
      :position="position"
      :desc="question_list[index].ask_desc"
    ></research-mode>-->
    <Rules :text="rules_text" v-if="ruleModeShow" @close="closeRelus"></Rules>

    <van-popup class="success-full-screen" @close="rightAnswer" v-if="isRight" v-model="show">
      <div @click="closeRight" class="right-imgs"></div>
    </van-popup>

    <!-- 答错了的部分 -->
    <van-dialog
      v-if="!isRight"
      v-model="show"
      class="wrong-modal hide"
      show-confirm-button
      confirm-button-text="下一题"
      confirm-button-color="#333333"
      :before-close="wrongAnswer"
    >
      <div class="wrong-wrap">
        <div class="wrong-imgs"></div>
        <div class="wrong-title">呜呜~回答错误！</div>
        <div class="wrong-desc">加油，再想想哦~争取答对</div>
      </div>
      <!-- <div @click="closeModal" class="close-modal"></div> -->
    </van-dialog>

    <Score v-if="isScoreActive" :score="totalScore" :onClose="handleScoreClose"></Score>
  </div>
</template>

<script>
import * as Api from '../api/index'
import headerInfo from '@/components/headerInfo.vue'
import ResearchMode from '@/components/researchMode.vue'
import topicZero from '@/components/topicZero.vue'
import topicOne from '@/components/topicOne.vue'
import topicTwo from '@/components/topicTwo.vue'
import topicThree from '@/components/topicThree.vue'
import Rules from '@/components/rules.vue'
import questionNum from '@/components/questionNum.vue'
import Score from '@/components/score.vue'

export default {
  name: 'doTest',
  data() {
    return {
      week_info: {},
      index: 0, // 当前题目下标
      question_list: [], // 当前周数的列表
      isRight: false,
      show: false,
      researchModeShow: false, // 研究模式显示判断
      position: {
        x: 0,
        y: 2,
        z: 0
      }, // 研究模式的位置 数字代表rem x--left y--bottom z--z-index
      student_answer: '', // 学生答案
      reload: 0, // 是否刷新页面
      rules_text: '本次作业共10题，每题2.5分。',
      ruleModeShow: false,
      totalScore: 0, // 测试所得分
      ansTimes: 0,
      isRight: false,
      isScoreActive: false,
      isAudioSwitchOn: true // 语音读题开关
    }
  },
  components: {
    topicOne,
    topicTwo,
    topicThree,
    topicZero,
    ResearchMode,
    Rules,
    questionNum,
    headerInfo,
    Score
  },
  mounted() {
    this.$rightPlayer = new Audio(window.mp3.rightAnswerMp3)
    this.$wrongPlayer = new Audio(window.mp3.wrongAnswerMp3)

    this.$readPlayer = new Audio()

    this.init()

    document.addEventListener(
      'WeixinJSBridgeReady',
      e => {
        // play然后马上暂停，提前去加载音频
        this.$rightPlayer.play()
        this.stopRightPlayer()
        this.$wrongPlayer.play()
        this.stopWrongPlayer()

        this.playAudio(this.audioContents[0].url)
      },
      false
    )
  },
  watch: {
    index() {
      this.catchVideo()
    }
  },
  computed: {
    timesCN() {
      const { times } = this.$route.params
      // eslint-disable-next-line no-nested-ternary
      return times === '1' ? '一' : times === '2' ? '二' : times === '3' ? '三' : '四'
    }
  },
  methods: {
    // 初始化数据---题目详情
    async init() {
      const { week, times } = this.$route.params
      const res = await Api.getQuestionList({
        week,
        times: times - 1,
        type: 'x'
      })
      if (res.status === 0) {
        const question_ids = []

        const { question_list, week_info } = res.content

        question_list.forEach(ele => {
          question_ids.push(ele.question_id)
        })

        const audios = await Api.getQuestionAudioAll({
          questionIds: question_ids.join(',')
        })
        this.audioContents = audios.content

        this.question_list = question_list
        this.week_info = week_info
        this.$store.dispatch('changLoadingStatus', false)
      }
    },

    switchAudioPlay() {
      this.isAudioSwitchOn = !this.isAudioSwitchOns
    },

    async catchVideo() {
      this.isAudioSwitchOn && this.playAudio(this.audioContents[this.index].url)
    },

    playAudio(src) {
      this.$readPlayer.src = src
      this.$readPlayer.play()
    },

    closeRight() {
      this.show = false
      this.stopRightPlayer()
    },

    closeWrong() {
      this.show = false
      this.stopWrongPlayer()
    },

    stopRightPlayer() {
      this.$rightPlayer.pause()
      this.$rightPlayer.currentTime = 0
    },

    stopWrongPlayer() {
      this.$wrongPlayer.pause()
      this.$wrongPlayer.currentTime = 0
    },

    stopReadPlayer() {
      this.$readPlayer.pause()
      this.$readPlayer.currentTime = 0
    },

    // 显示作业要求model
    showRelusModel() {
      this.ruleModeShow = true
    },
    // 关闭规则说明
    closeRelus() {
      this.ruleModeShow = false
    },
    // 上一个问题
    toLastQuestion() {
      if (this.index === 0) {
        this.$toast('当前已是第一个问题')
      } else {
        this.index -= 1
        this.reload = this.reload + 1
      }
    },

    handleScoreClose() {
      this.isScoreActive = false
      wx.miniProgram.navigateBack()
    },
    // 下一个问题
    toNextQuestion() {
      const { length } = this.question_list
      if (this.index === length - 1) {
        this.isScoreActive = true
        // this.$toast(`当前总共获得${this.totalScore}分,即将返回作业详情页面。。`)
        this.ansTimes += 1
        // setTimeout(() => {
        //   this.handleScoreClose()
        // }, 1000)
      } else {
        this.index += 1
        this.reload = this.reload + 1
      }
    },
    // 跳到任意题
    goIndex(i) {
      this.index = i
      this.reload = this.reload + 1
    },
    // 获取答案正确与否 --判断题
    getResult_judge(data) {
      this.student_answer = data.data // 学生答案
      this.stopReadPlayer()
      if (data.desc === '正确') {
        // 设置下标为正确 right
        this.$rightPlayer.play()
        this.isRight = true
        this.show = true
        this.setRightError(true)
        if (this.ansTimes === 0) {
          this.totalScore += 2.5
        }
        // 需要提交数据
        this.submitHomeworkData(0)
        setTimeout(() => {
          this.closeRight()
          this.toNextQuestion()
        }, 1000)
      } else {
        // 设置下标为false
        this.$wrongPlayer.play()
        this.isRight = false
        this.show = true
        this.setRightError(false)
        this.submitHomeworkData(1)
        setTimeout(() => {
          this.closeWrong()
          this.toNextQuestion()
        }, 1000)
      }
    },
    // 单选题返回
    getResult_single(data) {
      this.student_answer = data.data // 学生答案
      this.stopReadPlayer()
      if (data.desc === '正确') {
        // 设置下标为正确 right
        this.$rightPlayer.play()
        this.isRight = true
        this.show = true
        this.setRightError(true)
        if (this.ansTimes === 0) {
          this.totalScore += 2.5
        }
        // 需要提交数据
        this.submitHomeworkData(0)
        setTimeout(() => {
          this.closeRight()
          this.toNextQuestion()
        }, 1000)
      } else {
        // 设置下标为false
        this.$wrongPlayer.play()
        this.isRight = false
        this.show = true
        this.setRightError(false)
        this.submitHomeworkData(1)
        setTimeout(() => {
          this.closeWrong()
          this.toNextQuestion()
        }, 1000)
      }
      // this.toNextQuestion()
    },
    // 执行题返回结果
    getResult_chess(data) {
      this.stopReadPlayer()
      if (data === '正确') {
        // 设置下标为正确 right
        this.$rightPlayer.play()
        this.isRight = true
        this.show = true
        this.setRightError(true)
        if (this.ansTimes === 0) {
          this.totalScore += 2.5
        }
        // 需要提交数据
        this.submitHomeworkData(0)
        setTimeout(() => {
          this.closeRight()
          this.toNextQuestion()
        }, 1000)
      } else {
        // 设置下标为false
        this.$wrongPlayer.play()
        this.isRight = false
        this.show = true
        this.setRightError(false)
        this.submitHomeworkData(1)
        setTimeout(() => {
          this.closeWrong()
          this.toNextQuestion()
        }, 1000)
      }
      // this.toNextQuestion()
    },
    // 其他返回结果
    getResult_qt(data) {
      this.stopReadPlayer()
      if (data === '正确') {
        // 设置下标为正确 right
        this.$rightPlayer.play()
        this.isRight = true
        this.show = true
        if (this.ansTimes === 0) {
          this.totalScore += 2.5
        }
        this.setRightError(true)
        // 需要提交数据
        this.submitHomeworkData(0)
        setTimeout(() => {
          this.closeRight()
          this.toNextQuestion()
        }, 1000)
      } else {
        // 设置下标为false
        this.$wrongPlayer.play()
        this.isRight = false
        this.show = true
        this.setRightError(false)
        this.submitHomeworkData(1)
        setTimeout(() => {
          this.closeWrong()
          this.toNextQuestion()
        }, 1000)
      }
      // this.toNextQuestion()
    },
    // right or error
    setRightError(type) {
      this.$set(this.question_list, this.index, {
        ...this.question_list[this.index],
        right: type
      })
    },
    // 错误答案的事件
    wrongAnswer(action, done) {
      if (action === 'confirm') {
        this.toNextQuestion()
        done()
      } else {
        this.$set(this.question_list, this.index, {
          ...this.question_list[this.index],
          reload: this.question_list[this.index].reload + 1
        })
        done()
      }
    },
    // 正确答案的事件
    rightAnswer(action, done) {
      if (action === 'confirm') {
        this.toNextQuestion()
        done()
      }
    },
    // 进入研究模式
    gotoResearchMode() {
      this.researchModeShow = true
    },
    // 关闭研究模式
    closeResearch() {
      this.researchModeShow = false
    },
    // 提交数据打谱
    submitHomeworkData(isRight) {
      const { week, times } = this.$route.params
      const params = {
        week,
        times: times - 1,
        question_id: this.question_list[this.index].question_id,
        is_right: isRight,
        is_x_type: 1,
        student_answer: this.student_answer,
        type: 'x', // 作业项目类型--2 3 6 x
        question_type: 7 // 题目真正的类型
      }
      Api.answer(params).then(res => {
        if (res.status === 0) {
          console.log(res)
        } else {
          this.$toast(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* 重置样式 */
.wrong-modal.hide {
  .van-button {
    display: none !important;
  }
}
</style>

<style scoped lang="scss">
.doTest {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  background: #fff5da;

  .header {
    width: 100%;
    height: halvePx(80);
    background: rgba(244, 229, 194, 1);
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      color: rgba(51, 51, 51, 1);

      &.week {
        font-size: halvePx(28);
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        margin-left: halvePx(40);
        margin-right: halvePx(125);
      }

      &.questionId {
        font-size: halvePx(28);
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        margin-right: halvePx(40);
      }
    }
  }

  .mes {
    width: halvePx(670);
    height: halvePx(155);
    display: flex;
    align-items: center;
    margin: auto;

    .mes-left {
      flex: 1;
      height: 100%;

      .left-header {
        font-size: halvePx(28);
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin: halvePx(30) auto;
        display: flex;
        align-items: center;

        span {
          display: inline-block;
          width: halvePx(40);
          height: halvePx(50);
          line-height: halvePx(50);
          background: rgba(244, 229, 194, 1);
          text-align: center;
        }
      }

      .left-footer {
        font-size: halvePx(30);
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }

    .mes-right {
      img {
        width: halvePx(110);
        height: halvePx(110);
      }
    }
  }

  .answers {
    width: 80%;
    display: flex;
    margin: halvePx(50) auto 0;
    .btn-img {
      flex: 0 0 halvePx(85);
      height: halvePx(580);
      display: flex;
      justify-content: center;
      > img {
        display: block;
        width: halvePx(50);
      }
    }
    .answers-choose {
      flex: 1;
    }
  }

  .researchText {
    width: 100%;
    text-align: center;
    font-size: halvePx(30);
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(160, 140, 94, 1);
    margin: halvePx(40) auto;
  }

  .researchButton {
    margin: auto;
    width: halvePx(540);
    height: halvePx(100);
    line-height: halvePx(100);
    text-align: center;
    background: #7db9ff;
    border-radius: halvePx(50);
    font-size: halvePx(30);
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
}

.right-img {
  width: halvePx(80);
  height: halvePx(80);
  display: block;
  margin: halvePx(20) auto;
}

.right-text {
  width: 100%;
  margin: halvePx(20) auto halvePx(40);
  text-align: center;
}
</style>
